<template>
  <footer class="footer">
    <!-- Środkowa informacja: prawa autorskie i właściciel -->
    <div class="footer__info footer__info--center">
      {{ t('all-rights-reserved') }}. VS Tech PL Sp. z o.o.
    </div>
    <!-- Prawa strona: wersja aplikacji (pobierana z env) -->
    <div class="footer__info">{{ t('version') }} {{ version }}</div>
  </footer>
</template>

<script>
export default {
  // Komponent stopki wyświetlający wersję oraz dane o prawach autorskich
  data() {
    return {
      // Wersja aplikacji zdefiniowana w .env lub w package.json (przez build)
      version: process.env.VUE_APP_VERSION_NAME
    };
  }
}
</script>

<style scoped>
/* Stopka: informacja o właścicielu wyśrodkowana, wersja aplikacji przy prawej
   krawędzi — jak w projekcie referencyjnym. */
.footer {
  display: flex;
  align-items: center;
  min-height: 44px;
  padding: var(--spacing-sm) var(--spacing-lg);
  background: var(--surface-secondary);
  border-top: 1px solid var(--border-default);
}

.footer__info {
  font-size: var(--font-size-xs);
  color: var(--text-muted);
}

.footer__info--center {
  flex: 1 1 auto;
  text-align: center;
  /* kompensacja szerokości bloku z wersją, żeby tekst był optycznie na środku */
  padding-left: 8rem;
}

</style>
